import { ApiService, GenericError} from './api-main'
import TokenService from './token-service'
import store from '../store'

const SettlementService = {
    getOutstandingList: async function(paramId) {
        const url = 'main/settlement/search?version=2&settlementStatusId='+paramId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            console.log(response)
            return ApiService.validateResponse(response, '2600')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    createSettlement: async function(currencyId,totalAmountPayable,totalAmountReceived,transactionIds) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };
        const url = 'main/settlement'
        const params = {
            currencyId : currencyId,
            retailBranchId : store.state.misc.appBranchId,
            totalAmountPayable : totalAmountPayable,
            totalAmountReceived : totalAmountReceived,
            transactionIds : transactionIds,
        }
        console.log("params createSettlement", params)
        try {

            /*const response = await ApiService.post(url, params)

            return ApiService.validateResponse(response, '0500')*/
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log(response)
            const resTransaction = response.data;

            return resTransaction;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    updateSettlement: async function(id, params) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };
        const url = 'main/settlement/exc/'+id

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log(response)
            const resTransaction = response.data;

            return resTransaction;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getSettlement: async function(id) {
        const url = 'main/settlement/'+id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '2602')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    generatePayNowQRCode: async function(settlementId, txnAmt) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };
        const url     = 'main/dbsrapid/paymentrequest'
        const params  = {
            txnRefNo    : settlementId,
            refTypeId 	: 0,
            trxAmount   : txnAmt
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log("generatePayNowQRCode", response)
            const resTransaction = response.data;

            return resTransaction;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    checkoutCreditPayment: async function(id) {
        ApiService.removeFormData('CREDIT_HPP_ID');
        const url = 'main/checkout/createHostedPaymentPage/'+id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            const result = ApiService.validateResponse(response, 'WN00400');
            if(result != undefined) {
                ApiService.saveFormData("CREDIT_HPP_ID", result.id);
                return result._links.redirect.href
            }
            return result;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    checkoutCreditStatus: async function() {
        if(!ApiService.getFormData('CREDIT_HPP_ID')) { 
            return '0000';
        }
        const url = 'main/checkout/payment/success/' + ApiService.getFormData('CREDIT_HPP_ID')
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, {})
            ApiService.removeFormData('CREDIT_HPP_ID');
            return response.data.status
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },
}

export default SettlementService